import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class ActiveGatewayControlServerPlugin extends SmartenitPlugin {
  public setActiveGateway(state: boolean, subscribe?: boolean): any {
    return this.setAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      'SelectedAsActiveGateway',
      { value: state },
      subscribe || false
    );
  }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'SelectedAsActiveGateway') {
      this.state.SelectedAsActiveGateway = response.value;
      if (
        this.device &&
        (this.device.meta === undefined || this.device.meta === null)
      ) {
        this.device.meta = {};
      }
      if (this.device.meta.activeGateway != response.value) {
        this.device.meta.activeGateway = response.value;
        const sub = this.device.save().subscribe( (res) => {
          sub.unsubscribe();
        });
      }
      this._onUpdate.next({ SelectedAsActiveGateway: response.value });
    } else if (attribute === 'SmartSelectionEnabled') {
      this.state.SmartSelectionEnabled = response.value;
      this._onUpdate.next({ SmartSelectionEnabled: response.value });
    } else if (attribute === 'SmartSelectionLastUpdatedAt') {
      this.state.SmartSelectionLastUpdatedAt = response.value;
      this._onUpdate.next({ SmartSelectionLastUpdatedAt: response.value });
    } else if (attribute === 'UserMetric') {
      this.state.UserMetric = response.value;
      this._onUpdate.next({ UserMetric: response.value });
    } else if (attribute === 'CurrentActiveGateway') {
      this.state.CurrentActiveGateway = response.value;
      this._onUpdate.next({ CurrentActiveGateway: response.value });
    } else if (attribute === 'RouterConcentrator') {
      this.state.RouterConcentrator = response.value;
      this._onUpdate.next({ RouterConcentrator: response.value });
    }

    return this.state;
  }
}
